var _path, _line, _line2, _line3, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssessments(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6364 22.875H2C1.51675 22.875 1.125 22.4832 1.125 22V2C1.125 1.51675 1.51675 1.125 2 1.125H13.1387L16.0428 4.31948L18.5114 7.57802V22C18.5114 22.4832 18.1196 22.875 17.6364 22.875Z",
    stroke: "#26CE83",
    strokeWidth: 2.25
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 7.63635,
    y1: 10.7039,
    x2: 14.1818,
    y2: 10.7039,
    stroke: "#26CE83",
    strokeWidth: 1.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 7.63635,
    y1: 14.5232,
    x2: 14.1818,
    y2: 14.5232,
    stroke: "#26CE83",
    strokeWidth: 1.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 7.63635,
    y1: 17.7961,
    x2: 14.1818,
    y2: 17.7961,
    stroke: "#26CE83",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.28638 11.6799C4.34497 11.7385 4.44458 11.7385 4.50317 11.6799L6.22583 9.95728C6.28442 9.89868 6.28442 9.79907 6.22583 9.74048L6.01489 9.52954C5.9563 9.47095 5.86255 9.47095 5.80396 9.52954L4.39771 10.9358L3.7356 10.2795C3.677 10.2209 3.58325 10.2209 3.52466 10.2795L3.31372 10.4905C3.25513 10.5491 3.25513 10.6487 3.31372 10.7073L4.28638 11.6799Z",
    fill: "#26CE83"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.28638 14.9531C4.34497 15.0117 4.44458 15.0117 4.50317 14.9531L6.22583 13.2305C6.28442 13.1719 6.28442 13.0723 6.22583 13.0137L6.01489 12.8027C5.9563 12.7441 5.86255 12.7441 5.80396 12.8027L4.39771 14.209L3.7356 13.5527C3.677 13.4941 3.58325 13.4941 3.52466 13.5527L3.31372 13.7637C3.25513 13.8223 3.25513 13.9219 3.31372 13.9805L4.28638 14.9531Z",
    fill: "#26CE83"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.28638 18.2263C4.34497 18.2849 4.44458 18.2849 4.50317 18.2263L6.22583 16.5037C6.28442 16.4451 6.28442 16.3455 6.22583 16.2869L6.01489 16.0759C5.9563 16.0173 5.86255 16.0173 5.80396 16.0759L4.39771 17.4822L3.7356 16.8259C3.677 16.7673 3.58325 16.7673 3.52466 16.8259L3.31372 17.0369C3.25513 17.0955 3.25513 17.1951 3.31372 17.2537L4.28638 18.2263Z",
    fill: "#26CE83"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessments);
export default __webpack_public_path__ + "static/media/assessments.c28bfaf4fabc61683caafab31fd85139.svg";
export { ForwardRef as ReactComponent };